'use es6';

import { useEffect } from 'react';
import { useTheme } from 'styled-components';
import { setTrellisThemeSingleton } from 'tinymce-themes/utils/trellis';
export default function useTrellisTheme() {
  const theme = useTheme();
  useEffect(() => {
    setTrellisThemeSingleton(theme);
  }, [theme]);
  return theme;
}